import { has, reduce } from 'lodash';
import { StyleList, StyleVariables } from './customization.interfaces';

export const styleList: StyleList = {
  ThemeColor: {
    inputType: 'color',
    list: [
      {
        selector: '.theme-color',
        styles: 'color'
      },
      {
        selector: '.tariff-info-icon',
        styles: 'color'
      },
      {
        selector: '.tickets-download-info-icon',
        styles: 'color'
      },
      {
        selector: '.basket-package-product-text-color',
        styles: 'color'
      },
      {
        selector: '.dot-pulse-wrapper',
        styles: 'color'
      },
      {
        selector: 'app-exhibition-card ls-card i',
        styles: 'color'
      },
      {
        selector: 'footer.footer .footer__title',
        styles: 'color'
      },
      {
        selector: 'p-dropdown .p-dropdown-item.p-highlight',
        styles: 'background-color'
      },
      {
        selector: '.p-dropdown-panel .p-dropdown-items .p-dropdown-item:not(.p-highlight):not(.p-disabled).p-focus',
        styles: 'background-color'
      },
      {
        selector: '.selected-event',
        styles: 'background-color'
      }
    ]
  },
  HeadlineColor: {
    inputType: 'color',
    list: [
      {
        selector: '.headline-container .headline',
        styles: 'color'
      }
    ]
  },
  HeadlineDescriptionColor: {
    inputType: 'color',
    list: [
      {
        selector: '.headline-container .headline-description',
        styles: 'color'
      }
    ]
  },
  ThemeHeadingTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.theme-heading',
        styles: 'color'
      }
    ]
  },
  ThemeHeadingBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.theme-heading',
        styles: 'background-color'
      }
    ]
  },
  ThemeTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.theme-text-color',
        styles: 'color'
      },
      {
        selector: 'ls-dropdown .p-dropdown-item',
        styles: 'color'
      },
      {
        selector: 'p-tieredmenusub',
        styles: 'color'
      },
      {
        selector: 'ls-sidebar',
        styles: 'color'
      }
    ]
  },
  ThemeLinkTxColor: {
    inputType: 'color',
    list: [
      {
        selector: 'main a',
        styles: 'color'
      }
    ]
  },
  ThemeBackgroundColor: {
    inputType: 'color',
    list: [
      {
        selector: '.page-background-without-image',
        styles: 'background-color'
      }
    ]
  },
  SectionContentBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.section-content',
        styles: 'background-color'
      }
    ]
  },
  SectionContentHeadingTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.section-content-heading',
        styles: 'color'
      }
    ]
  },
  EventSelectionHeadingTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.event-selection-heading',
        styles: 'color'
      }
    ]
  },
  EventSelectionSubheadingTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.event-selection-subheading',
        styles: 'color'
      }
    ]
  },
  EventTitleName: {
    inputType: 'color',
    list: [
      {
        selector: '.event-name',
        styles: 'color'
      }
    ]
  },
  EventDuration: {
    inputType: 'color',
    list: [
      {
        selector: '.event-duration',
        styles: 'color'
      }
    ]
  },
  PackageBorderColor: {
    inputType: 'color',
    list: [
      {
        selector: '.package-type',
        styles: 'border-color'
      },
      {
        selector: '.package-type__header',
        styles: 'border-color'
      },
      {
        selector: '.package-type__footer',
        styles: 'border-color'
      }
    ]
  },
  PackageHeaderBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.package-type__header',
        styles: 'background-color'
      }
    ]
  },
  PackageHeaderTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.package-type__header',
        styles: 'color'
      }
    ]
  },
  PackageWarningTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.package-type-warning-message .p-message',
        styles: 'color'
      },
      {
        selector: '.package-type-warning-message .p-message .p-message-icon',
        styles: 'color'
      }
    ]
  },
  PackageWarningBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.package-type-warning-message .p-message',
        styles: 'background-color'
      }
    ]
  },
  PackageWarningBorderColor: {
    inputType: 'color',
    list: [
      {
        selector: '.package-type-warning-message .p-message',
        styles: 'border-color'
      }
    ]
  },
  PackageProductBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.package-product',
        styles: 'background-color'
      }
    ]
  },
  PackageTariffTypeNameTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.package-tariff-type-name',
        styles: 'color'
      }
    ]
  },
  PackageTariffNameTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.package-tariff-name',
        styles: 'color'
      }
    ]
  },
  PackageTariffDescriptionTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.package-tariff-info-text',
        styles: 'color'
      }
    ]
  },
  PackageTariffBorderColor: {
    inputType: 'color',
    list: [
      {
        selector: '.package-tariff',
        styles: 'border-color'
      }
    ]
  },
  PackageTariffWarningTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.package-tariff-available-tariffs',
        styles: 'color'
      },
      {
        selector: '.package-tariff-sold-out',
        styles: 'color'
      },
      {
        selector: '.package-tariff-workshop-sold-out',
        styles: 'color'
      },
      {
        selector: '.package-tariff-warning-message',
        styles: 'color'
      }
    ]
  },
  PackageTariffPriceTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.package-tariff-price',
        styles: 'color'
      }
    ]
  },
  PackagePriceBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.package-price-wrapper',
        styles: 'background-color'
      }
    ]
  },
  PackagePriceTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.package-price',
        styles: 'color'
      }
    ]
  },
  PackageFooterBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.package-type__footer',
        styles: 'background-color'
      }
    ]
  },
  PackageFooterTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.package-type__footer',
        styles: 'color'
      }
    ]
  },
  SplitButtonPrimaryBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.split-button-primary button',
        styles: 'background-color'
      },
      {
        selector: '.split-button-primary button',
        styles: 'border-color'
      }
    ]
  },
  SplitButtonPrimaryHoverBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.split-button-primary button:hover',
        styles: 'background-color'
      }
    ]
  },
  SplitButtonPrimaryTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.split-button-primary button span',
        styles: 'color'
      },
      {
        selector: '.split-button-primary button i',
        styles: 'color'
      }
    ]
  },
  SplitButtonPrimaryHoverTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.split-button-primary:hover button span',
        styles: 'color'
      },
      {
        selector: '.split-button-primary:hover button i',
        styles: 'color'
      }
    ]
  },
  SelectButtonActiveBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.select-button .ls-buttonset .ls-button.ls-highlight',
        styles: 'background-color'
      },
      {
        selector: '.select-button .ls-buttonset .ls-button.ls-highlight',
        styles: 'border-color'
      }
    ]
  },
  SelectButtonActiveTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.select-button .ls-buttonset .ls-button.ls-highlight',
        styles: 'color'
      }
    ]
  },
  SelectButtonActiveHoverBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.ls-buttonset .ls-button.ls-highlight:hover',
        styles: 'background-color'
      },
      {
        selector: '.ls-buttonset .ls-button.ls-highlight:hover',
        styles: 'border-color'
      }
    ]
  },
  SelectButtonActiveHoverTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.ls-buttonset .ls-button.ls-highlight:hover',
        styles: 'color'
      }
    ]
  },
  SelectButtonInactiveBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.select-button .ls-buttonset .ls-button',
        styles: 'background-color'
      }
    ]
  },
  SelectButtonInactiveBorderColor: {
    inputType: 'color',
    list: [
      {
        selector: '.select-button .ls-buttonset .ls-button',
        styles: 'border-color'
      }
    ]
  },
  SelectButtonInactiveTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.select-button .ls-buttonset .ls-button',
        styles: 'color'
      }
    ]
  },
  SelectButtonInactiveHoverBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.ls-buttonset .ls-button:hover',
        styles: 'background-color'
      }
    ]
  },
  SelectButtonInactiveHoverBorderColor: {
    inputType: 'color',
    list: [
      {
        selector: '.ls-buttonset .ls-button:hover',
        styles: 'border-color'
      }
    ]
  },
  SelectButtonInactiveHoverTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.ls-buttonset .ls-button:hover',
        styles: 'color'
      }
    ]
  },
  SwitchButtonActiveBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.p-inputswitch.p-inputswitch-checked .p-inputswitch-slider',
        styles: 'background-color'
      }
    ]
  },
  SwitchButtonActiveDisabledBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.p-inputswitch.p-inputswitch-checked.p-disabled .p-inputswitch-slider',
        styles: 'background-color'
      }
    ]
  },
  SwitchButtonActiveBorderColor: {
    inputType: 'color',
    list: [
      {
        selector: '.p-inputswitch.p-inputswitch-checked .p-inputswitch-slider',
        styles: 'border-color'
      }
    ]
  },
  SwitchButtonActiveDisabledBorderColor: {
    inputType: 'color',
    list: [
      {
        selector: '.p-inputswitch.p-inputswitch-checked.p-disabled .p-inputswitch-slider',
        styles: 'border-color'
      }
    ]
  },
  SwitchButtonActiveButtonBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.p-inputswitch.p-inputswitch-checked .p-inputswitch-slider::before',
        styles: 'background-color'
      }
    ]
  },
  SwitchButtonActiveDisabledButtonBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.p-inputswitch.p-inputswitch-checked.p-disabled .p-inputswitch-slider::before',
        styles: 'background-color'
      }
    ]
  },
  SwitchButtonInactiveBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.p-inputswitch .p-inputswitch-slider',
        styles: 'background-color'
      }
    ]
  },
  SwitchButtonInactiveDisabledBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.p-inputswitch.p-disabled .p-inputswitch-slider',
        styles: 'background-color'
      }
    ]
  },
  SwitchButtonInactiveBorderColor: {
    inputType: 'color',
    list: [
      {
        selector: '.p-inputswitch .p-inputswitch-slider',
        styles: 'border-color'
      }
    ]
  },
  SwitchButtonInactiveDisabledBorderColor: {
    inputType: 'color',
    list: [
      {
        selector: '.p-inputswitch.p-disabled .p-inputswitch-slider',
        styles: 'border-color'
      }
    ]
  },
  SwitchButtonInactiveButtonBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.p-inputswitch .p-inputswitch-slider::before',
        styles: 'background-color'
      }
    ]
  },
  SwitchButtonInactiveDisabledButtonBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.p-inputswitch.p-disabled .p-inputswitch-slider::before',
        styles: 'background-color'
      }
    ]
  },
  ButtonPrimaryBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.button-primary',
        styles: 'background-color'
      },
      {
        selector: '.p-fileupload-buttonbar .p-fileupload-choose.p-button',
        styles: 'background-color'
      },
      {
        selector: '.p-fileupload-buttonbar p-button:not(.p-disabled) .p-button',
        styles: 'background-color'
      }
    ]
  },
  ButtonPrimaryBorderColor: {
    inputType: 'color',
    list: [
      {
        selector: '.button-primary',
        styles: 'border-color'
      },
      {
        selector: '.p-fileupload-buttonbar .p-fileupload-choose.p-button',
        styles: 'border-color'
      },
      {
        selector: '.p-fileupload-buttonbar p-button:not(.p-disabled) .p-button',
        styles: 'border-color'
      }
    ]
  },
  ButtonPrimaryTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.button-primary span',
        styles: 'color'
      },
      {
        selector: 'a.button-primary',
        styles: 'color'
      },
      {
        selector: '.p-fileupload-buttonbar .p-fileupload-choose.p-button',
        styles: 'color'
      },
      {
        selector: '.p-fileupload-buttonbar p-button:not(.p-disabled) .p-button',
        styles: 'color'
      }
    ]
  },
  ButtonPrimaryHoverBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.button-primary:enabled:hover',
        styles: 'background-color'
      },

      {
        selector: 'a.button-primary:hover',
        styles: 'background-color'
      },
      {
        selector: '.p-fileupload-buttonbar .p-fileupload-choose.p-button:hover',
        styles: 'background-color'
      },
      {
        selector: '.p-fileupload-buttonbar p-button:not(.p-disabled) .p-button:hover',
        styles: 'background-color'
      }
    ]
  },
  ButtonPrimaryHoverBorderColor: {
    inputType: 'color',
    list: [
      {
        selector: '.button-primary:enabled:hover',
        styles: 'border-color'
      },
      {
        selector: 'a.button-primary:hover',
        styles: 'border-color'
      },
      {
        selector: '.p-fileupload-buttonbar .p-fileupload-choose.p-button:hover',
        styles: 'border-color'
      },
      {
        selector: '.p-fileupload-buttonbar p-button:not(.p-disabled) .p-button:hover',
        styles: 'border-color'
      }
    ]
  },
  ButtonPrimaryHoverTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.button-primary:enabled:hover span',
        styles: 'color'
      },
      {
        selector: 'a.button-primary:hover',
        styles: 'color'
      },
      {
        selector: 'a.button-primary:hover span',
        styles: 'color'
      },
      {
        selector: '.p-fileupload-buttonbar .p-fileupload-choose.p-button:hover',
        styles: 'color'
      },
      {
        selector: '.p-fileupload-buttonbar p-button:not(.p-disabled) .p-button:hover',
        styles: 'color'
      }
    ]
  },
  ButtonSecondaryBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.button-secondary',
        styles: 'background-color'
      }
    ]
  },
  ButtonSecondaryBorderColor: {
    inputType: 'color',
    list: [
      {
        selector: '.button-secondary',
        styles: 'border-color'
      }
    ]
  },
  ButtonSecondaryTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.button-secondary span',
        styles: 'color'
      },
      {
        selector: 'a.button-secondary',
        styles: 'color'
      }
    ]
  },
  ButtonSecondaryHoverBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.button-secondary:enabled:hover',
        styles: 'background-color'
      },
      {
        selector: 'a.button-secondary:hover',
        styles: 'background-color'
      }
    ]
  },
  ButtonSecondaryHoverBorderColor: {
    inputType: 'color',
    list: [
      {
        selector: '.button-secondary:enabled:hover',
        styles: 'border-color'
      },
      {
        selector: 'a.button-secondary:hover',
        styles: 'border-color'
      }
    ]
  },
  ButtonSecondaryHoverTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.button-secondary:enabled:hover span',
        styles: 'color'
      },
      {
        selector: 'a.button-secondary:hover',
        styles: 'color'
      },
      {
        selector: 'a.button-secondary:hover span',
        styles: 'color'
      }
    ]
  },
  ConfirmationVoucherTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.order-summary-voucher-tariff-voucher-code',
        styles: 'color'
      }
    ]
  },
  ConfirmationDropdownBorderColor: {
    inputType: 'color',
    list: [
      {
        selector: '.order-summary-dropdown-toggle',
        styles: 'border-color'
      },
      {
        selector: '.order-summary-dropdown',
        styles: 'border-color'
      }
    ]
  },
  ConfirmationDropdownTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.order-summary-dropdown-item span',
        styles: 'color'
      },
      {
        selector: '.order-summary-dropdown-toggle span',
        styles: 'color'
      },
      {
        selector: '.order-summary-dropdown-icon',
        styles: 'fill'
      }
    ]
  },
  ConfirmationDropdownHoverTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.order-summary-dropdown-item:hover span',
        styles: 'color'
      },
      {
        selector: '.order-summary-dropdown-item:hover .order-summary-dropdown-icon',
        styles: 'fill'
      }
    ]
  },
  ConfirmationDropdownHoverBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.order-summary-dropdown-item:hover',
        styles: 'background-color'
      }
    ]
  },
  ConfirmationProductNameTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.order-summary-product-name',
        styles: 'color'
      }
    ]
  },
  ConfirmationProductPriceTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.order-summary-product-price',
        styles: 'color'
      },
      {
        selector: '.order-summary-tariff-price',
        styles: 'color'
      },
      {
        selector: '.order-summary-tariff-workshop-price',
        styles: 'color'
      }
    ]
  },
  ConfirmationTariffBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.order-summary-product-type-tariff',
        styles: 'background-color'
      }
    ]
  },
  ConfirmationTariffTotalPriceBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.order-summary-tariff-price',
        styles: 'background-color'
      }
    ]
  },
  ConfirmationTariffWorkshopsIconTitleColor: {
    inputType: 'color',
    list: [
      {
        selector: '.order-summary-tariff-workshops-icon-title svg',
        styles: 'fill'
      },
      {
        selector: '.order-summary-tariff-workshops-icon-title',
        styles: 'color'
      }
    ]
  },
  ConfirmationTariffWorkshopBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.order-summary-tariff-workshop-wrapper',
        styles: 'background-color'
      }
    ]
  },
  ConfirmationTariffPersonTypeTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.order-summary-tariff-person-type-name',
        styles: 'color'
      }
    ]
  },
  ConfirmationTariffHolderNameTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.order-summary-tariff-holder-name',
        styles: 'color'
      }
    ]
  },
  ConfirmationTariffHolderEmailTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.order-summary-tariff-holder-email',
        styles: 'color'
      }
    ]
  },
  ConfirmationTariffHolderInfoBorderColor: {
    inputType: 'color',
    list: [
      {
        selector: '.order-summary-tariff-holder-info',
        styles: 'border-color'
      }
    ]
  },
  ConfirmationPaymentTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.order-summary-payment-methods .enabled h4',
        styles: 'color'
      }
    ]
  },
  ConfirmationPaymentHoverTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.order-summary-payment-methods .enabled:hover h4',
        styles: 'color'
      }
    ]
  },
  ConfirmationPaymentBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.order-summary-payment-methods .enabled',
        styles: 'background-color'
      }
    ]
  },
  ConfirmationPaymentHoverBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.order-summary-payment-methods .enabled:hover',
        styles: 'background-color'
      }
    ]
  },
  ProductCounterButtonTxColor: {
    inputType: 'color',
    list: [
      {
        selector: 'app-tariff-counter button',
        styles: 'color'
      },
      {
        selector: 'app-package-counter button',
        styles: 'color'
      }
    ]
  },
  ProductCounterButtonBgColor: {
    inputType: 'color',
    list: [
      {
        selector: 'app-tariff-counter button',
        styles: 'background-color'
      },
      {
        selector: 'app-package-counter button',
        styles: 'background-color'
      }
    ]
  },
  ProductCounterButtonBorderColor: {
    inputType: 'color',
    list: [
      {
        selector: 'app-tariff-counter button',
        styles: 'border-color'
      },
      {
        selector: 'app-package-counter button',
        styles: 'border-color'
      }
    ]
  },
  ProductCounterSpinnerColor: {
    inputType: 'color',
    list: [
      {
        selector: 'app-tariff-counter .product-counter-spinner',
        styles: 'border-color'
      },
      {
        selector: 'app-package-counter .product-counter-spinner',
        styles: 'border-color'
      }
    ]
  },
  SelfRegToggleProductColor: {
    inputType: 'color',
    list: [
      {
        selector: '.self-registration-toggle-product-icon',
        styles: 'fill'
      }
    ]
  },
  SelfRegToggleProductDisabledColor: {
    inputType: 'color',
    list: [
      {
        selector: 'self-registration-toggle-product-icon--disabled',
        styles: 'fill'
      }
    ]
  },
  TabAreaBg: {
    inputType: 'color',
    list: [
      {
        selector: '.navigation-tabs-content',
        styles: 'background-color'
      }
    ]
  },
  TabAreaBorderColor: {
    inputType: 'color',
    list: [
      {
        selector: '.navigation-tabs-item.navigation-tabs-item--active',
        styles: 'border-left-color'
      },
      {
        selector: '.navigation-tabs-item.navigation-tabs-item--active',
        styles: 'border-top-color'
      },
      {
        selector: '.navigation-tabs-item.navigation-tabs-item--active',
        styles: 'border-right-color'
      },
      {
        selector: '.navigation-tabs-item',
        styles: 'border-color'
      },
      {
        selector: '.navigation-tabs',
        styles: 'border-color'
      },
      {
        selector: '.navigation-tabs-content',
        styles: 'border-color'
      }
    ]
  },
  TabAreaHeadingTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.navigation-tabs-content .navigation-tabs-content-heading',
        styles: 'color'
      }
    ]
  },
  TabIconColor: {
    inputType: 'color',
    list: [
      {
        selector: '.navigation-tabs-item .navigation-tabs-item-icon',
        styles: 'color'
      }
    ]
  },
  TabActiveIconColor: {
    inputType: 'color',
    list: [
      {
        selector: '.navigation-tabs-item.navigation-tabs-item--active .navigation-tabs-item-icon',
        styles: 'color'
      }
    ]
  },
  TabActiveBg: {
    inputType: 'color',
    list: [
      {
        selector: '.navigation-tabs-item.navigation-tabs-item--active',
        styles: 'background-color'
      }
    ]
  },
  TabActiveText: {
    inputType: 'color',
    list: [
      {
        selector: '.navigation-tabs-item.navigation-tabs-item--active',
        styles: 'color'
      }
    ]
  },
  TabInactiveBg: {
    inputType: 'color',
    list: [
      {
        selector: '.navigation-tabs-item',
        styles: 'background-color'
      }
    ]
  },
  TabInactiveText: {
    inputType: 'color',
    list: [
      {
        selector: '.navigation-tabs-item',
        styles: 'color'
      }
    ]
  },
  StepNavigationBgColor: {
    inputType: 'color',
    list: [
      {
        selector: 'app-step-navigation nav#step-navigation',
        styles: 'background-color'
      }
    ]
  },
  AreaBlockDash: {
    inputType: 'color',
    list: [
      {
        selector: '.navigation-steps li .pi-check-circle',
        styles: 'color'
      },
      {
        selector: '.navigation-steps li::before',
        styles: 'color'
      }
    ]
  },
  AreaBlockBgActive: {
    inputType: 'color',
    list: [
      {
        selector: '.navigation-steps li a.active-link',
        styles: 'background-color'
      }
    ]
  },
  AreaBlockTxActive: {
    inputType: 'color',
    list: [
      {
        selector: '.navigation-steps li a.active-link span',
        styles: 'color'
      },
      {
        selector: '.navigation-steps li i.pi-circle-fill',
        styles: 'color'
      }
    ]
  },
  AreaBlockBgFutureActive: {
    inputType: 'color',
    list: [
      {
        selector: '.navigation-steps li a.future-step',
        styles: 'background-color'
      }
    ]
  },
  AreaBlockTxtFutureActive: {
    inputType: 'color',
    list: [
      {
        selector: '.navigation-steps li i:has(+ a.future-step)',
        styles: 'color'
      },
      {
        selector: '.navigation-steps li a.future-step span',
        styles: 'color'
      }
    ]
  },
  AreaBlockBgFuture: {
    inputType: 'color',
    list: [
      {
        selector: '.navigation-steps li.step.disabled div',
        styles: 'background-color'
      }
    ]
  },
  AreaBlockTxFuture: {
    inputType: 'color',
    list: [
      {
        selector: '.navigation-steps li.step.disabled div span',
        styles: 'color'
      },
      {
        selector: '.navigation-steps li.step.disabled i',
        styles: 'color'
      }
    ]
  },
  AreaBlockBgInactive: {
    inputType: 'color',
    list: [
      {
        selector: '.navigation-steps li .pi-check-circle + a',
        styles: 'background-color'
      }
    ]
  },
  AreaBlockTxInactive: {
    inputType: 'color',
    list: [
      {
        selector: '.navigation-steps li .pi-check-circle',
        styles: 'color'
      },
      {
        selector: '.navigation-steps li .pi-check-circle + a',
        styles: 'color'
      }
    ]
  },
  VoucherBlockBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.voucher-wrapper',
        styles: 'background-color'
      }
    ]
  },
  VoucherRedeemButtonBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.voucher-redeem-button',
        styles: 'background-color'
      }
    ]
  },
  VoucherRedeemButtonBorderColor: {
    inputType: 'color',
    list: [
      {
        selector: '.voucher-redeem-button',
        styles: 'border-color'
      }
    ]
  },
  VoucherRedeemButtonTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.voucher-redeem-button span',
        styles: 'color'
      }
    ]
  },
  VoucherRedeemButtonHoverBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.voucher-redeem-button:enabled:hover',
        styles: 'background-color'
      }
    ]
  },
  VoucherRedeemButtonHoverBorderColor: {
    inputType: 'color',
    list: [
      {
        selector: '.voucher-redeem-button:enabled:hover',
        styles: 'border-color'
      }
    ]
  },
  VoucherRedeemButtonHoverTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.voucher-redeem-button:enabled:hover span',
        styles: 'color'
      }
    ]
  },
  VoucherTariffBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.voucher-tariff',
        styles: 'background-color'
      }
    ]
  },
  VoucherTariffBorderColor: {
    inputType: 'color',
    list: [
      {
        selector: '.voucher-tariff',
        styles: 'border-color'
      }
    ]
  },
  VoucherTariffNameTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.voucher-tariff-name',
        styles: 'color'
      }
    ]
  },
  VoucherTariffPriceTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.voucher-tariff-price',
        styles: 'color'
      }
    ]
  },
  VoucherTariffDescriptionTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.voucher-tariff-info-text',
        styles: 'color'
      }
    ]
  },
  VoucherTariffVoucherCodeBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.voucher-tariff-code-wrapper',
        styles: 'background-color'
      }
    ]
  },
  VoucherTariffVoucherCodeColor: {
    inputType: 'color',
    list: [
      {
        selector: '.voucher-tariff-voucher-code',
        styles: 'color'
      }
    ]
  },
  VoucherTariffRemoveIconBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.voucher-tariff-remove-voucher-icon',
        styles: 'background-color'
      }
    ]
  },
  VoucherTariffRemoveIconColor: {
    inputType: 'color',
    list: [
      {
        selector: '.voucher-tariff-remove-voucher-icon',
        styles: 'color'
      }
    ]
  },
  PromoCodeDiscountColor: {
    inputType: 'color',
    list: [
      {
        selector: '.promo-code-discount',
        styles: 'color'
      },
      {
        selector: '.basket-promo-code-discount',
        styles: 'color'
      },
      {
        selector: '.buyer-order-overview__order-promo-code-discount',
        styles: 'color'
      },
      {
        selector: '.ticket-assignment-order-overview__order-promo-code-discount',
        styles: 'color'
      },
      {
        selector: '.order-summary-promo-code-discount',
        styles: 'color'
      }
    ]
  },
  PromoCodePriceColor: {
    inputType: 'color',
    list: [
      {
        selector: '.promo-code-price',
        styles: 'color'
      },
      {
        selector: '.basket-promo-code-price',
        styles: 'color'
      },
      {
        selector: '.buyer-order-overview__order-promo-code-price',
        styles: 'color'
      },
      {
        selector: '.ticket-assignment-order-overview__order-promo-code-price',
        styles: 'color'
      },
      {
        selector: '.order-summary-promo-code-price',
        styles: 'color'
      }
    ]
  },
  PromoCodeDiscountedPriceColor: {
    inputType: 'color',
    list: [
      {
        selector: '.promo-code-discounted-price',
        styles: 'color'
      },
      {
        selector: '.basket-promo-code-discounted-price',
        styles: 'color'
      },
      {
        selector: '.buyer-order-overview__order-promo-code-discounted-price',
        styles: 'color'
      },
      {
        selector: '.ticket-assignment-order-overview__order-promo-code-discounted-price',
        styles: 'color'
      },
      {
        selector: '.order-summary-promo-code-discounted-price',
        styles: 'color'
      }
    ]
  },
  PromoCodeBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.discount-promo-code-wrapper',
        styles: 'background-color'
      }
    ]
  },
  PromoCodeColor: {
    inputType: 'color',
    list: [
      {
        selector: '.discount-promo-code',
        styles: 'color'
      }
    ]
  },
  PromoCodeRemoveIconBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.discount-promo-code-remove-icon',
        styles: 'background-color'
      }
    ]
  },
  PreferredTariffBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.preferred-tariff',
        styles: 'background-color'
      }
    ]
  },
  PreferredTariffBorderColor: {
    inputType: 'color',
    list: [
      {
        selector: '.preferred-tariff',
        styles: 'border-color'
      }
    ]
  },
  PreferredTariffNameTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.preferred-tariff-name',
        styles: 'color'
      }
    ]
  },
  PreferredTariffPriceTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.preferred-tariff-price',
        styles: 'color'
      }
    ]
  },
  PreferredTariffDescriptionTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.preferred-tariff-info-text',
        styles: 'color'
      }
    ]
  },
  RadioLabelTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.decorated-radio-button .radio-button-label',
        styles: 'color'
      },
      {
        selector: '.decorated-radio-button .sending-option-icon',
        styles: 'fill'
      }
    ]
  },
  RadioBorder: {
    inputType: 'color',
    list: [
      {
        selector: '.decorated-radio-button .radio-button-label::before',
        styles: 'border-color'
      }
    ]
  },
  RadioCheckedColor: {
    inputType: 'color',
    list: [
      {
        selector: '.decorated-radio-button input:checked ~ .radio-button-label::before',
        styles: 'border-color'
      },
      {
        selector: '.decorated-radio-button.radio-button--checked .radio-button-label::before',
        styles: 'border-color'
      }
    ]
  },
  RadioBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.decorated-radio-button-row',
        styles: 'background-color'
      },
      {
        selector: '.legitimation-option-box',
        styles: 'background-color'
      }
    ]
  },
  BorderedRadioBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.bordered-radio-button-row .decorated-radio-button',
        styles: 'background-color'
      }
    ]
  },
  BorderedRadioBorderColor: {
    inputType: 'color',
    list: [
      {
        selector: '.bordered-radio-button-row .decorated-radio-button',
        styles: 'border-color'
      }
    ]
  },
  BorderedRadioCheckedBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.bordered-radio-button-row .decorated-radio-button.radio-button--checked',
        styles: 'background-color'
      }
    ]
  },
  BorderedRadioCheckedBorderColor: {
    inputType: 'color',
    list: [
      {
        selector: '.bordered-radio-button-row .decorated-radio-button.radio-button--checked',
        styles: 'border-color'
      }
    ]
  },
  CheckboxRowBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.decorated-checkbox-row',
        styles: 'background-color'
      }
    ]
  },
  CheckboxLabelTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.decorated-checkbox .checkbox-label',
        styles: 'color'
      }
    ]
  },
  CheckboxBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.decorated-checkbox .checkbox-wrapper input:checked ~ .checkmark',
        styles: 'background-color'
      }
    ]
  },
  CheckboxBorderColor: {
    inputType: 'color',
    list: [
      {
        selector: '.decorated-checkbox .checkbox-wrapper .checkmark',
        styles: 'border-color'
      }
    ]
  },
  CheckboxCheckMarkColor: {
    inputType: 'color',
    list: [
      {
        selector: '.decorated-checkbox .checkbox-wrapper .checkmark::after',
        styles: 'border-color'
      }
    ]
  },
  CheckboxErrorBorderColor: {
    inputType: 'color',
    list: [
      {
        selector: '.decorated-checkbox .checkbox-wrapper input.ng-invalid ~ .checkmark',
        styles: 'border-color'
      },
      {
        selector: '.decorated-checkbox--invalid .checkbox-wrapper .checkmark',
        styles: 'border-color'
      }
    ]
  },
  CheckboxPolicyTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.checkbox-policy-text .p-message',
        styles: 'color'
      }
    ]
  },
  CheckboxPolicyTxBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.checkbox-policy-text .p-message',
        styles: 'background-color'
      }
    ]
  },
  CheckboxPolicyTxBorderColor: {
    inputType: 'color',
    list: [
      {
        selector: '.checkbox-policy-text .p-message',
        styles: 'border-color'
      }
    ]
  },
  ValidInputLabelColor: {
    inputType: 'color',
    list: [
      {
        selector: '.input-wrapper ls-input-text.ng-valid.ng-touched .ls-input-label',
        styles: 'color'
      },
      {
        selector: '.parking-reservation-wrapper .input-wrapper input.ng-valid.ng-touched ~ label',
        styles: 'color'
      },
      {
        selector: '.dropdown-wrapper .dropdown select.dropdown--selected + label',
        styles: 'color'
      },
      {
        selector:
          '.date-picker-wrapper .date-picker:not(.date-picker--disabled).date-picker--filled p-calendar + label',
        styles: 'color'
      },
      {
        selector:
          '.dropdown-wrapper .decorated-dropdown:not(.decorated-dropdown--disabled).decorated-dropdown--filled label',
        styles: 'color'
      }
    ]
  },
  InputBorderColor: {
    inputType: 'color',
    list: [
      {
        selector: '.input-wrapper input',
        styles: 'border-color'
      },
      {
        selector: '.dropdown-wrapper .dropdown select',
        styles: 'border-color'
      },
      {
        selector: '.date-picker-wrapper input',
        styles: 'border-color'
      },
      {
        selector: '.dropdown-wrapper .decorated-dropdown p-dropdown .p-dropdown',
        styles: 'border-color'
      }
    ]
  },
  InputBorderHoverColor: {
    inputType: 'color',
    list: [
      {
        selector: '.input-wrapper input:enabled:hover',
        styles: 'border-color'
      },
      {
        selector: '.dropdown-wrapper .dropdown select:enabled:hover',
        styles: 'border-color'
      },
      {
        selector: '.date-picker-wrapper input:enabled:hover',
        styles: 'border-color'
      },
      {
        selector: '.dropdown-wrapper .decorated-dropdown p-dropdown .p-dropdown:hover',
        styles: 'border-color'
      }
    ]
  },
  InputBorderFocusColor: {
    inputType: 'color',
    list: [
      {
        selector: '.input-wrapper input:enabled:focus',
        styles: 'border-color'
      },
      {
        selector: '.dropdown-wrapper .dropdown select:enabled:focus',
        styles: 'border-color'
      },
      {
        selector: '.date-picker-wrapper input:enabled:focus',
        styles: 'border-color'
      },
      {
        selector: '.dropdown-wrapper .decorated-dropdown p-dropdown .p-dropdown.p-inputwrapper-focus',
        styles: 'border-color'
      }
    ]
  },
  RequiredErrLabelTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.input-wrapper ls-input-text.ng-invalid.ng-dirty .ls-input-wrapper input + ls-label label',
        styles: 'color'
      },
      {
        selector: '.parking-reservation-wrapper .input-wrapper input.ng-invalid.ng-dirty ~ label',
        styles: 'color'
      }
    ]
  },
  RequiredErrTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.input-error-wrapper small',
        styles: 'color'
      },
      {
        selector: '.select-error-wrapper small',
        styles: 'color'
      }
    ]
  },
  RequiredErrBrdColor: {
    inputType: 'color',
    list: [
      {
        selector: '.input-error-wrapper small',
        styles: 'background-color'
      },
      {
        selector: '.select-error-wrapper small',
        styles: 'background-color'
      }
    ]
  },
  HeaderNavTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.header',
        styles: 'color'
      }
    ]
  },
  HeaderNavBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.header',
        styles: 'background-color'
      },
      {
        selector: '.header .mobile-navigation',
        styles: 'background-color'
      }
    ]
  },
  HeaderNavBorderColor: {
    inputType: 'color',
    list: [
      {
        selector: '.mobile-navigation ul',
        styles: 'border-color'
      }
    ]
  },
  HeaderNavActiveLinkTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.header a.active-navigation-link',
        styles: 'color'
      }
    ]
  },
  BannerEventInfoTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.event-info',
        styles: 'color'
      }
    ]
  },
  BannerEventInfoBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.event-info',
        styles: 'background-color'
      }
    ]
  },
  TicketOwnerEmailListTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.order-summary-tariff-holder-email',
        styles: 'color'
      }
    ]
  },
  InfoMessageTxColor: {
    inputType: 'color',
    list: [
      {
        selector: 'ls-message .p-message-info-inline',
        styles: 'color'
      },
      {
        selector: 'ls-message .p-message-info-inline .p-message-icon',
        styles: 'color'
      }
    ]
  },
  InfoMessageBgColor: {
    inputType: 'color',
    list: [
      {
        selector: 'ls-message .p-message-info-inline',
        styles: 'background-color'
      }
    ]
  },
  InfoMessageBorderColor: {
    inputType: 'color',
    list: [
      {
        selector: 'ls-message .p-message-info-inline',
        styles: 'border-color'
      }
    ]
  },
  ErrorHeaderBgColor: {
    inputType: 'color',
    list: [
      {
        selector: 'app-feedback-message .message-header',
        styles: 'background-color'
      }
    ]
  },
  ErrorHeaderTxtColor: {
    inputType: 'color',
    list: [
      {
        selector: 'app-feedback-message .message-header',
        styles: 'color'
      }
    ]
  },
  ErrorBodyTxColor: {
    inputType: 'color',
    list: [
      {
        selector: 'app-feedback-message .message-list span',
        styles: 'color'
      }
    ]
  },
  ErrorBodyBgColor: {
    inputType: 'color',
    list: [
      {
        selector: 'app-feedback-message .message-body',
        styles: 'background-color'
      },
      {
        selector: 'app-feedback-message:after',
        styles: 'border-top-color'
      }
    ]
  },
  LoaderColor: {
    inputType: 'color',
    list: [
      {
        selector: '.loader-wrapper svg rect',
        styles: 'fill'
      },
      {
        selector: '.autocomplete-loading::after',
        styles: 'background-color'
      }
    ]
  },
  TariffTypeBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.tariff-type',
        styles: 'background-color'
      }
    ]
  },
  TariffTypeNameTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.tariff-type-name',
        styles: 'color'
      }
    ]
  },
  TariffBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.tariff',
        styles: 'background-color'
      }
    ]
  },
  TariffBorderColor: {
    inputType: 'color',
    list: [
      {
        selector: '.tariff',
        styles: 'border-color'
      }
    ]
  },
  TariffNameTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.tariff-name',
        styles: 'color'
      }
    ]
  },
  TariffDescriptionTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.tariff-info-text',
        styles: 'color'
      }
    ]
  },
  TariffWarningTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.tariff-available-tariffs',
        styles: 'color'
      },
      {
        selector: '.tariff-sold-out',
        styles: 'color'
      },
      {
        selector: '.tariff-warning-message',
        styles: 'color'
      },
      {
        selector: '.invalid-contingent-tariff',
        styles: 'color'
      }
    ]
  },
  TariffPriceTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.tariff-price',
        styles: 'color'
      }
    ]
  },
  WorkshopHeadingTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.workshop-heading',
        styles: 'color'
      },
      {
        selector: '.workshop-heading svg',
        styles: 'fill'
      }
    ]
  },
  WorkshopDateTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.workshop-date',
        styles: 'color'
      }
    ]
  },
  WorkshopNameTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.workshop-name',
        styles: 'color'
      }
    ]
  },
  WorkshopPriceTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.workshop-price',
        styles: 'color'
      }
    ]
  },
  WorkshopRoomTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.workshop-room .workshop-room-name',
        styles: 'color'
      }
    ]
  },
  WorkshopDetailsTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.workshop-details',
        styles: 'color'
      }
    ]
  },
  WorkshopDescriptionTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.workshop-description',
        styles: 'color'
      }
    ]
  },
  WorkshopSoldOutWarningTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.tariff-workshop-sold-out',
        styles: 'color'
      }
    ]
  },
  ProductPriceTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.product-price',
        styles: 'color'
      }
    ]
  },
  ProductGroupBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.product-group',
        styles: 'background-color'
      }
    ]
  },
  ProductGroupNameTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.product-group-name',
        styles: 'color'
      }
    ]
  },
  ProductGroupDescriptionTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.product-group-description',
        styles: 'color'
      }
    ]
  },
  DatePickerHighlightBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.p-datepicker span.p-highlight',
        styles: 'background-color'
      }
    ]
  },
  DatePickerHighlightTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.p-datepicker span.p-highlight',
        styles: 'color'
      }
    ]
  },
  DatePickerDisabledHighlightBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.p-datepicker table.p-datepicker-calendar td span.p-disabled',
        styles: 'background-color'
      },
      {
        selector: '.p-monthpicker span.p-monthpicker-month.p-disabled',
        styles: 'background-color'
      },
      {
        selector: '.p-yearpicker span.p-yearpicker-year.p-disabled',
        styles: 'background-color'
      }
    ]
  },
  DatePickerDisabledHighlightTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.p-datepicker table.p-datepicker-calendar td span.p-disabled',
        styles: 'color'
      },
      {
        selector: '.p-monthpicker span.p-monthpicker-month.p-disabled',
        styles: 'color'
      },
      {
        selector: '.p-yearpicker span.p-yearpicker-year.p-disabled',
        styles: 'color'
      }
    ]
  },
  DatePickerHoverHighlightBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.p-datepicker table.p-datepicker-calendar td span:not(.p-disabled):hover',
        styles: 'background-color'
      },
      {
        selector: '.p-monthpicker span.p-monthpicker-month:not(.p-disabled):hover',
        styles: 'background-color'
      },
      {
        selector: '.p-yearpicker span.p-yearpicker-year:not(.p-disabled):hover',
        styles: 'background-color'
      }
    ]
  },
  DatePickerHoverHighlightTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.p-datepicker table.p-datepicker-calendar td span:not(.p-disabled):hover',
        styles: 'color'
      },
      {
        selector: '.p-monthpicker span.p-monthpicker-month:not(.p-disabled):hover',
        styles: 'color'
      },
      {
        selector: '.p-yearpicker span.p-yearpicker-year:not(.p-disabled):hover',
        styles: 'color'
      }
    ]
  },
  SendingOptionsBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.sending-options-wrapper',
        styles: 'background-color'
      }
    ]
  },
  SendingOptionsHeadingColor: {
    inputType: 'color',
    list: [
      {
        selector: '.sending-options-heading',
        styles: 'color'
      }
    ]
  },
  StickyFooterTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.sticky-footer',
        styles: 'color'
      }
    ]
  },
  StickyFooterBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.sticky-footer',
        styles: 'background-color'
      }
    ]
  },
  StickyFooterBorderColor: {
    inputType: 'color',
    list: [
      {
        selector: '.sticky-footer',
        styles: 'border-color'
      }
    ]
  },
  FooterBackgroundColor: {
    inputType: 'color',
    list: [
      {
        selector: 'footer.footer',
        styles: 'background-color'
      }
    ]
  },
  FooterBorderColor: {
    inputType: 'color',
    list: [
      {
        selector: 'footer.footer',
        styles: 'border-color'
      }
    ]
  },
  FooterLegalLinksTextColor: {
    inputType: 'color',
    list: [
      {
        selector: 'footer .footer__legal-links a',
        styles: 'color'
      }
    ]
  },
  BasketCountTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.header .basket-count',
        styles: 'color'
      }
    ]
  },
  BasketCountBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.header .basket-count',
        styles: 'background-color'
      }
    ]
  },
  BasketButtonDividerColor: {
    inputType: 'color',
    list: [
      {
        selector: '.basket .basket-buttons-container',
        styles: 'border-color'
      }
    ]
  },
  BuyerOrderOverviewBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.buyer-order-overview',
        styles: 'background-color'
      }
    ]
  },
  BuyerOrderOverviewHeadingColor: {
    inputType: 'color',
    list: [
      {
        selector: '.buyer-order-overview-heading',
        styles: 'color'
      }
    ]
  },
  BuyerOrderOverviewTariffTypeColor: {
    inputType: 'color',
    list: [
      {
        selector: '.buyer-order-overview__order-tariff-type-name',
        styles: 'color'
      }
    ]
  },
  BuyerOrderOverviewTariffNameColor: {
    inputType: 'color',
    list: [
      {
        selector: '.buyer-order-overview__order-tariff-name',
        styles: 'color'
      }
    ]
  },
  BuyerOrderOverviewTariffVoucherCodeColor: {
    inputType: 'color',
    list: [
      {
        selector: '.buyer-order-overview__order-voucher-code',
        styles: 'color'
      }
    ]
  },
  BuyerOrderOverviewTariffPriceColor: {
    inputType: 'color',
    list: [
      {
        selector: '.buyer-order-overview__order-tariff-price',
        styles: 'color'
      }
    ]
  },
  BuyerOrderOverviewSubtotalTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.buyer-order-overview-subtotal-text',
        styles: 'color'
      }
    ]
  },
  BuyerOrderOverviewSubtotalPriceColor: {
    inputType: 'color',
    list: [
      {
        selector: '.buyer-order-overview-subtotal-price',
        styles: 'color'
      }
    ]
  },
  AssignmentAddTicketHolderSelectTextColor: {
    inputType: 'color',
    list: [
      {
        selector:
          'app-ticket-assignment .ticket-holder-select .p-dropdown-panel .p-dropdown-items p-dropdownitem:last-child li',
        styles: 'color'
      }
    ]
  },
  AssignmentOrderOverviewBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.ticket-assignment-order-overview__order',
        styles: 'background-color'
      }
    ]
  },
  AssignmentOrderOverviewValidBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.ticket-assignment-order-overview__order--valid',
        styles: 'background-color'
      }
    ]
  },
  AssignmentOrderOverviewValidBorderColor: {
    inputType: 'color',
    list: [
      {
        selector: '.ticket-assignment-order-overview__order--valid',
        styles: 'border-color'
      }
    ]
  },
  AssignmentOrderOverviewValidSelectedBorderColor: {
    inputType: 'color',
    list: [
      {
        selector: '.ticket-assignment-order-overview__order--valid--selected',
        styles: 'border-color'
      }
    ]
  },
  AssignmentOrderOverviewValidIconColor: {
    inputType: 'color',
    list: [
      {
        selector: '.ticket-assignment-order-overview__order--valid .ticket-assignment-order-overview__order-icon',
        styles: 'color'
      }
    ]
  },
  AssignmentOrderOverviewValidTariffTypeColor: {
    inputType: 'color',
    list: [
      {
        selector:
          '.ticket-assignment-order-overview__order--valid .ticket-assignment-order-overview__order-tariff-type-name',
        styles: 'color'
      }
    ]
  },
  AssignmentOrderOverviewValidTariffNameColor: {
    inputType: 'color',
    list: [
      {
        selector:
          '.ticket-assignment-order-overview__order--valid .ticket-assignment-order-overview__order-tariff-name',
        styles: 'color'
      }
    ]
  },
  AssignmentOrderOverviewValidVoucherCodeColor: {
    inputType: 'color',
    list: [
      {
        selector:
          '.ticket-assignment-order-overview__order--valid .ticket-assignment-order-overview__order-voucher-code',
        styles: 'color'
      }
    ]
  },
  AssignmentOrderOverviewValidTariffPriceColor: {
    inputType: 'color',
    list: [
      {
        selector:
          '.ticket-assignment-order-overview__order--valid .ticket-assignment-order-overview__order-tariff-price',
        styles: 'color'
      }
    ]
  },
  AssignmentOrderOverviewValidTextColor: {
    inputType: 'color',
    list: [
      {
        selector:
          '.ticket-assignment-order-overview__order--valid .ticket-assignment-order-overview__order-new-ticket-holder',
        styles: 'color'
      },
      {
        selector: '.ticket-assignment-order-overview__order--valid .ticket-assignment-order-overview__order-full-name',
        styles: 'color'
      },
      {
        selector: '.ticket-assignment-order-overview__order--valid .ticket-assignment-order-overview__order-email',
        styles: 'color'
      },
      {
        selector: '.ticket-assignment-order-overview__order--valid .ticket-assignment-order-overview__order-contingent',
        styles: 'color'
      },
      {
        selector:
          '.ticket-assignment-order-overview__order--valid .ticket-assignment-order-overview__order-parking-license-plate-number',
        styles: 'color'
      }
    ]
  },
  AssignmentOrderOverviewInvalidBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.ticket-assignment-order-overview__order--invalid',
        styles: 'background-color'
      }
    ]
  },
  AssignmentOrderOverviewInvalidBorderColor: {
    inputType: 'color',
    list: [
      {
        selector: '.ticket-assignment-order-overview__order--invalid',
        styles: 'border-color'
      }
    ]
  },
  AssignmentOrderOverviewInvalidSelectedBorderColor: {
    inputType: 'color',
    list: [
      {
        selector: '.ticket-assignment-order-overview__order--invalid--selected',
        styles: 'border-color'
      }
    ]
  },
  AssignmentOrderOverviewInvalidIconColor: {
    inputType: 'color',
    list: [
      {
        selector: '.ticket-assignment-order-overview__order--invalid .ticket-assignment-order-overview__order-icon',
        styles: 'color'
      }
    ]
  },
  AssignmentOrderOverviewInvalidTariffTypeColor: {
    inputType: 'color',
    list: [
      {
        selector:
          '.ticket-assignment-order-overview__order--invalid .ticket-assignment-order-overview__order-tariff-type-name',
        styles: 'color'
      }
    ]
  },
  AssignmentOrderOverviewInvalidTariffNameColor: {
    inputType: 'color',
    list: [
      {
        selector:
          '.ticket-assignment-order-overview__order--invalid .ticket-assignment-order-overview__order-tariff-name',
        styles: 'color'
      }
    ]
  },
  AssignmentOrderOverviewInvalidTariffPriceColor: {
    inputType: 'color',
    list: [
      {
        selector:
          '.ticket-assignment-order-overview__order--invalid .ticket-assignment-order-overview__order-tariff-price',
        styles: 'color'
      }
    ]
  },
  AssignmentOrderOverviewInvalidVoucherCodeColor: {
    inputType: 'color',
    list: [
      {
        selector:
          '.ticket-assignment-order-overview__order--invalid .ticket-assignment-order-overview__order-voucher-code',
        styles: 'color'
      }
    ]
  },
  AssignmentOrderOverviewInvalidTextColor: {
    inputType: 'color',
    list: [
      {
        selector:
          '.ticket-assignment-order-overview__order--invalid .ticket-assignment-order-overview__order-new-ticket-holder',
        styles: 'color'
      },
      {
        selector:
          '.ticket-assignment-order-overview__order--invalid .ticket-assignment-order-overview__order-full-name',
        styles: 'color'
      },
      {
        selector: '.ticket-assignment-order-overview__order--invalid .ticket-assignment-order-overview__order-email',
        styles: 'color'
      },
      {
        selector:
          '.ticket-assignment-order-overview__order--invalid .ticket-assignment-order-overview__order-contingent',
        styles: 'color'
      },
      {
        selector:
          '.ticket-assignment-order-overview__order--invalid .ticket-assignment-order-overview__order-parking-license-plate-number',
        styles: 'color'
      }
    ]
  },
  AssignmentOrderOverviewNotAssignedBgColor: {
    inputType: 'color',
    list: [
      {
        selector: '.ticket-assignment-order-overview__order--not-assigned',
        styles: 'background-color'
      }
    ]
  },
  AssignmentOrderOverviewNotAssignedBorderColor: {
    inputType: 'color',
    list: [
      {
        selector: '.ticket-assignment-order-overview__order--not-assigned',
        styles: 'border-color'
      }
    ]
  },
  AssignmentOrderOverviewNotAssignedSelectedBdColor: {
    inputType: 'color',
    list: [
      {
        selector: '.ticket-assignment-order-overview__order--not-assigned--selected',
        styles: 'border-color'
      }
    ]
  },
  AssignmentOrderOverviewNotAssignedIconColor: {
    inputType: 'color',
    list: [
      {
        selector:
          '.ticket-assignment-order-overview__order--not-assigned .ticket-assignment-order-overview__order-icon',
        styles: 'color'
      }
    ]
  },
  AssignmentOrderOverviewNotAssignedTariffTypeColor: {
    inputType: 'color',
    list: [
      {
        selector:
          '.ticket-assignment-order-overview__order--not-assigned .ticket-assignment-order-overview__order-tariff-type-name',
        styles: 'color'
      }
    ]
  },
  AssignmentOrderOverviewNotAssignedTariffNameColor: {
    inputType: 'color',
    list: [
      {
        selector:
          '.ticket-assignment-order-overview__order--not-assigned .ticket-assignment-order-overview__order-tariff-name',
        styles: 'color'
      }
    ]
  },
  AssignmentOrderOverviewNotAssignedTariffPriceColor: {
    inputType: 'color',
    list: [
      {
        selector:
          '.ticket-assignment-order-overview__order--not-assigned .ticket-assignment-order-overview__order-tariff-price',
        styles: 'color'
      }
    ]
  },
  AssignmentOrderOverviewNotAssignedVoucherCodeColor: {
    inputType: 'color',
    list: [
      {
        selector:
          '.ticket-assignment-order-overview__order--not-assigned .ticket-assignment-order-overview__order-voucher-code',
        styles: 'color'
      }
    ]
  },
  AssignmentOrderOverviewNotAssignedTextColor: {
    inputType: 'color',
    list: [
      {
        selector:
          '.ticket-assignment-order-overview__order--not-assigned .ticket-assignment-order-overview__order-new-ticket-holder',
        styles: 'color'
      },
      {
        selector:
          '.ticket-assignment-order-overview__order--not-assigned .ticket-assignment-order-overview__order-full-name',
        styles: 'color'
      },
      {
        selector:
          '.ticket-assignment-order-overview__order--not-assigned .ticket-assignment-order-overview__order-email',
        styles: 'color'
      },
      {
        selector:
          '.ticket-assignment-order-overview__order--not-assigned .ticket-assignment-order-overview__order-contingent',
        styles: 'color'
      },
      {
        selector:
          '.ticket-assignment-order-overview__order--not-assigned .ticket-assignment-order-overview__order-parking-license-plate-number',
        styles: 'color'
      }
    ]
  },
  AssignmentOrderOverviewErrorMessageColor: {
    inputType: 'color',
    list: [
      {
        selector: '.ticket-assignment-order-overview__orders .ticket-assignment-order-overview__order-error-message',
        styles: 'color'
      }
    ]
  },
  AssignmentOrderOverviewSubtotalTxColor: {
    inputType: 'color',
    list: [
      {
        selector: '.ticket-assignment-order-overview__order-subtotal-text',
        styles: 'color'
      }
    ]
  },
  AssignmentOrderOverviewSubtotalPriceColor: {
    inputType: 'color',
    list: [
      {
        selector: '.ticket-assignment-order-overview__order-subtotal-price',
        styles: 'color'
      }
    ]
  },
  PaginatorColor: {
    inputType: 'color',
    list: [
      {
        selector: 'p-paginator .p-dropdown-item.p-highlight',
        styles: 'background-color'
      },
      {
        selector: 'p-paginator .p-paginator button',
        styles: 'color'
      }
    ]
  },
  PaginatorActivePageBgColor: {
    inputType: 'color',
    list: [
      {
        selector: 'p-paginator .p-paginator .p-paginator-page.p-highlight',
        styles: 'background-color'
      }
    ]
  },
  HighContrastButtonOutlineColor: {
    list: [
      {
        selector: 'p-button:not(.p-disabled) .p-button-primary:not(.p-button-icon-only):focus-visible',
        styles: 'outline-color'
      },
      {
        selector: 'p-button:not(.p-disabled) .p-button-secondary:not(.p-button-icon-only):focus-visible',
        styles: 'outline-color'
      },
      {
        selector: 'a.button-primary:focus-visible',
        styles: 'outline-color'
      }
    ]
  },
  HighContrastSwitchButtonOutlineColor: {
    list: [
      {
        selector: '.p-inputswitch:not(.p-disabled):focus-within .p-inputswitch-slider',
        styles: 'outline-color'
      }
    ]
  },
  HighContrastLinkTextDecoration: {
    list: [
      {
        selector: 'a:not(.button-primary)',
        styles: 'text-decoration'
      },
      {
        selector: 'a:not(.button-primary) span',
        styles: 'text-decoration'
      }
    ]
  }
};

export const generateSkinCss = (variables: StyleVariables): string =>
  reduce(
    variables,
    (cssString, value, variable) => {
      if (!has(styleList, variable) || !value) {
        return cssString;
      }

      return reduce(
        styleList[variable].list,
        (allStyles, { selector, styles }) => {
          const style = `${styles}: ${value} !important;`;
          return `${allStyles}${selector} {\n  ${style}\n}`;
        },
        cssString
      );
    },
    ''
  );
